import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class SupportService{
  // API Instance
  configConnection: any = new ConfigConnection();

  get(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}support?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  create(support){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
        // 'Content-Type':  'multipart/form-data',
      }
    };
    return axios.post(`${_.configConnection.apiInstance}support`, support, config);
  }

  edit(support, supportId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.put(`${_.configConnection.apiInstance}support/${supportId}`, support, config);
  }

  getById(supportId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}support/${supportId}`, config);
  }

  delete_support(supportId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}support/${supportId}`, config);
  }

  getCompanies(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company`, config);
  }

  getInactive(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}support/inactive?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  active_support(supportId, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}support/${supportId}/reactivate`, config);
  }
}
